import ScrollItem from './ScrollItem';
import './Member.css';
import './Glitch.css';
import SectionDecoration from './SectionDecoration';

import MemberH2Webp from '../img/Member-h2.webp';
import MemberH2 from '../img/Member-h2.png';
import MemberDecorationWebp from '../img/Member-decoration.webp';
import HIDETAKATENJINWebp from '../img/Member-icon/HIDETAKA-TENJIN.webp';
import HIDETAKATENJIN from '../img/Member-icon/HIDETAKA-TENJIN.png';
import AFROMANCEWebp from '../img/Member-icon/AFROMANCE.webp';
import AFROMANCE from '../img/Member-icon/AFROMANCE.png';
import MemberCardIconWebp from '../img/Member-icon/Member-card-icon.webp';
import MemberCardIcon from '../img/Member-icon/Member-card-icon.png';

import TomWebp from '../img/Member-icon/TOM.webp';
import Tom from '../img/Member-icon/TOM.png';
import JOHNWebp from '../img/Member-icon/JOHN.webp';
import JOHN from '../img/Member-icon/JOHN.png';
import GOWebp from '../img/Member-icon/GO.webp';
import GO from '../img/Member-icon/GO.png';
import ROCWebp from '../img/Member-icon/ROC.webp';
import ROC from '../img/Member-icon/ROC.png';
import TRADEMARKWebp from '../img/Member-icon/TRADEMARK.webp';
import TRADEMARK from '../img/Member-icon/TRADEMARK.png';
import SENWebp from '../img/Member-icon/SEN.webp';
import SEN from '../img/Member-icon/SEN.png';
import RyoWebp from '../img/Member-icon/Ryo.webp';
import Ryo from '../img/Member-icon/Ryo.png';
import BTFWebp from '../img/Member-icon/BTF.webp';
import BTF from '../img/Member-icon/BTF.png';
import TAKWebp from '../img/Member-icon/TAK.webp';
import TAK from '../img/Member-icon/TAK.png';
import MASSWebp from '../img/Member-icon/MASS.webp';
import MASS from '../img/Member-icon/MASS.png';
import KOWebp from '../img/Member-icon/KO.webp';
import KO from '../img/Member-icon/KO.png';
import TmellowWebp from '../img/Member-icon/T-mellow.webp';
import Tmellow from '../img/Member-icon/T-mellow.png';
import SkyWebp from '../img/Member-icon/Sky.webp';
import Sky from '../img/Member-icon/Sky.png';
import HolyWebp from '../img/Member-icon/Holy.webp';
import Holy from '../img/Member-icon/Holy.png';
import SPEEDWebp from '../img/Member-icon/SPEED.webp';
import SPEED from '../img/Member-icon/SPEED.png';
import SugarWebp from '../img/Member-icon/Sugar.webp';
import Sugar from '../img/Member-icon/Sugar.png';
import BASHIWebp from '../img/Member-icon/BASHI.webp';
import BASHI from '../img/Member-icon/BASHI.png';
import HSMWebp from '../img/Member-icon/HSM.webp';
import HSM from '../img/Member-icon/HSM.png';
import kiyoWebp from '../img/Member-icon/kiyo.webp';
import kiyo from '../img/Member-icon/kiyo.png';
import KENWebp from '../img/Member-icon/KEN.webp';
import KEN from '../img/Member-icon/KEN.png';
import NINJACODERWebp from '../img/Member-icon/NINJACODER.webp';
import NINJACODER from '../img/Member-icon/NINJACODER.png';
import TKYWebp from '../img/Member-icon/TKY.webp';
import TKY from '../img/Member-icon/TKY.png';
import SMAWebp from '../img/Member-icon/SMA.webp';
import SMA from '../img/Member-icon/SMA.png';
import BeachWebp from '../img/Member-icon/Beach.webp';
import Beach from '../img/Member-icon/Beach.png';

const MemberCard = (props) => {
    return (
        <div className="Member__card">
            <div className="Member__card__icon">
                <ScrollItem>
                    <picture>
                        <source type="image/webp" srcSet={props.imgWebp} />
                        <img src={props.imgPng} alt="Member icon" />
                    </picture>
                </ScrollItem>
            </div>
            <ScrollItem>
                <h3 className="Member__card__h3">{props.name}</h3>
            </ScrollItem>
            <ScrollItem>
                <p className="Member__card__text">{props.job}</p>
            </ScrollItem>
        </div>
    )
}

export default function Member() {
    return (
        <section className="Member" id="member">
            <div className="Member__upContainer">
                <div className="Member__leftContainer">
                    <h2 className="Member__h2">
                        <div className="Member__h2__img">
                            <ScrollItem>
                                <picture>
                                    <source type="image/webp" srcSet={MemberH2Webp} />
                                    <img src={MemberH2} alt="Member" />
                                </picture>
                            </ScrollItem>
                        </div>
                    </h2>
                    <ScrollItem>
                        <p className="Member__description">
                            We believe that the essence of Web 3.0 lies in the liberation of potential. The potential of
                            every human being.</p>
                    </ScrollItem>
                    <ScrollItem>
                        <p className="Member__description">
                            Rather than being forced by others to live the "right" way, individuals can now practice a way
                            of life that is consistent with their beliefs. They can become financially independent and every
                            individual will be equal. They will respect each other's individuality.</p>
                    </ScrollItem>
                    <ScrollItem>
                        <p className="Member__description">
                            You will truly be the master of yourself. We will not pander to the masses. Uniqueness is the
                            only way.</p>
                    </ScrollItem>
                    <ScrollItem>
                        <p className="Member__description">
                            We will at last become the "Sovereign Individual". No longer will it be a long-held dream of our
                            greatest philosophers.</p>
                    </ScrollItem>
                    <ScrollItem>
                        <p className="Member__description">
                            When in the near future multiple metaverses co-exist, we believe that people will be quick to
                            understand the need for a single identity that can cross over to all digital worlds.</p>
                    </ScrollItem>
                    <ScrollItem>
                        <p className="Member__description">
                            This is our mission. To establish an identity brand that can cross-over to all metaverses.
                        </p>
                    </ScrollItem>
                    <ScrollItem>
                        <p className="Member__description">
                            LIMITX. Unlimit yourself to infinite possibilities.
                        </p>
                    </ScrollItem>
                </div>
                <div className="Member__decoration">
                    <ScrollItem>
                        <img src={MemberDecorationWebp} alt="decoration" />
                    </ScrollItem>
                </div>
            </div>

            {/* <!-- ClanMember --> */}
            <div className="Member__profileContainer">
                <ScrollItem>
                    <h3 className="Member__profileTitle">ClanMember</h3>
                </ScrollItem>
                <div className="Member__profile">
                    <div className="Member__profile__icon--pc">
                        <ScrollItem>
                            <picture>
                                <source type="image/webp" srcSet={HIDETAKATENJINWebp} />
                                <img src={HIDETAKATENJIN} alt="HIDETAKA TENJIN icon" />
                            </picture>
                        </ScrollItem>
                    </div>

                    <div>
                        <div className="Member__profile__spContainer">
                            <div className="Member__profile__icon--sp">
                                <ScrollItem>
                                    <picture>
                                        <source type="image/webp" srcSet={HIDETAKATENJINWebp} />
                                        <img src={HIDETAKATENJIN} alt="HIDETAKA TENJIN icon" />
                                    </picture>
                                </ScrollItem>
                            </div>
                            <div className="Member__profile__rightContainer">
                                <ScrollItem>
                                    <h3 className="Member__profile__h3">TENJIN HIDETAKA</h3>
                                </ScrollItem>
                                <ScrollItem>
                                    <p className="Member__profile__job">Designer</p>
                                </ScrollItem>
                            </div>
                        </div>

                        <div className="Member__profile__descriptionContainer">

                            <ScrollItem>
                                <p className="Member__profile__description">
                                    Mecha design specialist, illustrator, and art director. Tenjin has produced many works in
                                    numerous robot/mecha series. Even in CG expressions, Tenjin draws a narrative on screen by
                                    consciously expressing the brush feeling and touch.
                                </p>
                            </ScrollItem>
                            <ScrollItem>
                                <p className="Member__profile__description">
                                    Tenjin has drawn box art for plastic models
                                    of the MG (master grade) series including
                                    Hasegawa's "Macross" series and Bandai Spirits' Gundam. He is also active in the field of
                                    animation as mechanical art designer of anime series "Macross Zero", "Macross Frontier" and
                                    "Genesis of Aquarion", the mechanical design of "Hellsing", "Macross Delta”, "Knights &
                                    Magic", “Super Robot WarsT”, “Back Arrow”, “Yasuke”, and “Space Battleship Yamato 2205”.
                                </p>
                            </ScrollItem>
                        </div>
                    </div>
                </div>
                <div className="Member__profile">
                    <div className="Member__profile__icon--pc">
                        <ScrollItem>
                            <picture>
                                <source type="image/webp" srcSet={AFROMANCEWebp} />
                                <img src={AFROMANCE} alt="AFROMANCE icon" />
                            </picture>
                        </ScrollItem>
                    </div>

                    <div>
                        <div className="Member__profile__spContainer">
                            <div className="Member__profile__icon--sp">
                                <ScrollItem>
                                    <picture>
                                        <source type="image/webp" srcSet={AFROMANCEWebp} />
                                        <img src={AFROMANCE} alt="AFROMANCE icon" />
                                    </picture>
                                </ScrollItem>
                            </div>
                            <div className="Member__profile__rightContainer">
                                <ScrollItem>
                                    <h3 className="Member__profile__h3">AFROMANCE</h3>
                                </ScrollItem>
                                <ScrollItem>
                                    <p className="Member__profile__job">Creative Director</p>
                                </ScrollItem>
                            </div>
                        </div>

                        <div className="Member__profile__descriptionContainer">
                            <ScrollItem>
                                <p className="Member__profile__description">
                                    Creative Director. CEO of Creative Company “Afro&Co”.<br />
                                    Co-Founder of Burning Japan, the regional event of Burning Man.<br />
                                    Major achievements include hosting the first foam party in Tokyo.
                                </p>
                            </ScrollItem>
                            <ScrollItem>
                                <p className="Member__profile__description">
                                    The “awapa” boom in Japan was started and accelerated by Afromance through the various
                                    collaborations with companies and brands such as LEXUS, and the famed outdoor festival
                                    “awafes”.
                                </p>
                            </ScrollItem>
                            <ScrollItem>
                                <p className="Member__profile__description">
                                    Also, Afromance produced “SAKURA CHILL BAR by Saga”, a bar smothered with
                                    1.2 million flower petals, the “Ghoul Restaurant” that featured the smash hit “Tokyo Ghoul”
                                    series, and the “BLOCK.FES”, an online music festival that brought in 2 million people
                                    during COVID.
                                </p>
                            </ScrollItem>
                        </div>
                    </div>
                </div>
            </div>

            <div className="Member__container">
                <MemberCard name="Tom" job="Operation Lead" imgWebp={TomWebp} imgPng={Tom} />
                <MemberCard name="JOHN" job="Project Design" imgWebp={JOHNWebp} imgPng={JOHN} />
                <MemberCard name="GO" job="Communication Lead" imgWebp={GOWebp} imgPng={GO} />
                <MemberCard name="ROC" job="Marketing Lead" imgWebp={ROCWebp} imgPng={ROC} />
                <MemberCard name="TRADEMARK" job="Creative Lead" imgWebp={TRADEMARKWebp} imgPng={TRADEMARK} />
                <MemberCard name="SEN" job="Owner of Alpha Channel" imgWebp={SENWebp} imgPng={SEN} />
                <MemberCard name="Ryo" job="Lead Developer" imgWebp={RyoWebp} imgPng={Ryo} />
                <MemberCard name="BTF" job="Concept Design" imgWebp={BTFWebp} imgPng={BTF} />
                <MemberCard name="TAK" job="Media Plannar" imgWebp={TAKWebp} imgPng={TAK} />
                <MemberCard name="MASS" job="Artist" imgWebp={MASSWebp} imgPng={MASS} />
                <MemberCard name="KO" job="management advisor" imgWebp={KOWebp} imgPng={KO} />
                <MemberCard name="T-mellow" job="Project Advisor" imgWebp={TmellowWebp} imgPng={Tmellow} />
                <MemberCard name="Sky" job="Influencer" imgWebp={SkyWebp} imgPng={Sky} />
                <MemberCard name="Holy" job="Global Marketing Lead - Asia" imgWebp={HolyWebp} imgPng={Holy} />
                <MemberCard name="SPEED" job="Global Communication" imgWebp={SPEEDWebp} imgPng={SPEED} />
                <MemberCard name="Sugar" job="Global Marketing - Asia" imgWebp={SugarWebp} imgPng={Sugar} />
                <MemberCard name="BASHI" job="Art Director" imgWebp={BASHIWebp} imgPng={BASHI} />
                <MemberCard name="HSM" job="Art Director" imgWebp={HSMWebp} imgPng={HSM} />
                {/* <MemberCard name="kiyo" job="Advisor" imgWebp={kiyoWebp} imgPng={kiyo} /> */}
                <MemberCard name="KEN" job="Community Designer" imgWebp={KENWebp} imgPng={KEN} />
                <MemberCard name="NINJACODER" job="enginner" imgWebp={NINJACODERWebp} imgPng={NINJACODER} />
                <MemberCard name="TKY" job="smartcontract developer" imgWebp={TKYWebp} imgPng={TKY} />
                <MemberCard name="SMA" job="Front-end developer" imgWebp={SMAWebp} imgPng={SMA} />
                <MemberCard name="Beach" job="Creative Assistant" imgWebp={BeachWebp} imgPng={Beach} />
            </div>

            {/* <!-- decoration --> */}
            <SectionDecoration />
        </section>
    )
}